import * as React from 'react';
import { connect } from 'react-redux';
import { Typography } from '@material-ui/core';
import { StyledComponentProps } from '@material-ui/core/styles';
import { IMediaQueryProps, WithMediaQuery } from '../../../../layout/withMediaQuery';
import { IApplicationState } from '../../../../store/ApplicationState';
import { IState as IMedicalExaminationState } from '../../../../common/store/medicalExaminations/state';
import { IActions as IMedicalExaminationActions, actionCreator as medicalExaminationActions } from '../../../../common/store/medicalExaminations/actions/creators';
import { useState } from 'react';
import { medicalExamination } from '../../../../model/medicalexamination';


interface IProps extends IMediaQueryProps, IMedicalExaminationState, IMedicalExaminationActions, IInnerProps {
}

interface IInnerProps extends StyledComponentProps {
    onUpdateMedicalExaminationDocument: (item: medicalExamination) => any;
    subscription: any;
    userId: string;
    expiresOn: Date;
    validFrom: Date;
    notes: string;
    // firebaseUri: string | undefined;
    // documentId: string | undefined;
}

export const MedicalExaminationDocument = (props: IProps) => {

    // const { isLoadingMex, newMedicalExamination } = props;
    // const [selectedFile, setSelectedFile] = useState(null);

    // const [documentId, setDocummentId] = useState(props.documentId);
    // const [firebaseUri, setFirebaseUri] = useState(props.firebaseUri);

    const winOpen = (firebaseUri: string) => {
        window.open(firebaseUri, '', 'height=600,width=600');
    }

    // props.LOADMEDICAL_EXAMINATION_BY_MEX_ID
    const getByMexId = (_documentId: string) => {
        props.loadMedicalExaminationsByMexId(props.userId, _documentId)
    }

    // props.ADD_MEDICAL_EXAMINATION
    const onFileChange = (event) => {
        console.log("onFileChange event:", event.target.files[0]);
        /*
        lastModified:1754641841782
        lastModifiedDate:Fri Aug 08 2025 10:30:41 GMT+0200 (Ora legale dell’Europa centrale) {}
        name:"output.pdf"
        size:9978
        type:"application/pdf"
        webkitRelativePath: ""
        */
        const file = event.target.files[0];
        // setSelectedFile(file);
        // convertBase64(file);
        convertBase64(file).then(b64 => {
            // console.log("onFileChange then base64:", b64);
            const ext = file.name.slice((file.name.lastIndexOf(".") - 1 >>> 0) + 2);
            const filename = file.name.substring(0, file.name.lastIndexOf('.')) || file.name;
            const type = file.type;
            // IL FILE Eè STATO CARICATO. E' possibile SALVARE
            const i = {
                expiresOn: props.expiresOn,
                validFrom: props.validFrom,
                extension: ext,
                isValidateByGym: false,
                loadedByUser: false,
                mimeType: type,
                notes: props.notes,
                fileName: filename,
                base64: b64,
            } as any;
            props.addMedicalExamination(props.userId, i);
        });
        // console.log("onFileChange base64:", base64);
    };

    // props.DELETE_MEDICAL_EXAMINATION
    const fileDelete = () => {
        if (props.selectedMedicalExamination) {
            const i = {
                _id: props.selectedMedicalExamination._id
            } as any;
            props.deleteMedicalExamination(props.userId, i);
        }
    }

    // React.useEffect(() => {
    // }, [props.newMedicalExamination])

    const convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);

            fileReader.onload = (e) => {
                const base64String = (e.target.result as string).split(',')[1]; // Extract Base64 string
                // resolve(fileReader.result);
                resolve(base64String);
            };

            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };

    // const onFileUpload = () => {
    //     if (selectedFile) {
    //         const formData = new FormData();
    //         formData.append(
    //             "myFile",
    //             selectedFile,
    //             selectedFile.name
    //         );
    //         console.log("onFileUpload selectedFile:", selectedFile);
    //         console.log("onFileUpload subscription:", props.userId);
    //         //addMedicalExamination()
    //         //axios.post("api/uploadfile", formData);
    //         const ext = selectedFile.name.slice((selectedFile.name.lastIndexOf(".") - 1 >>> 0) + 2);
    //         const b64 = convertBase64(selectedFile).then(b64 => {
    //             // console.log("onFileUpload base64:", x);
    //             // const base64String = (e.target.result as string).split(',')[1]; // Extract Base64 string
    //             // const i = {
    //             //     _id: undefined,
    //             //     expiresOn: props.expiresOn,
    //             //     validFrom: props.validFrom,
    //             //     sub: props.userId,
    //             //     nome: '',
    //             //     cognome: '',
    //             //     email: '',
    //             //     extension: ext,
    //             //     firebaseUri: '',
    //             //     isValidateByGym: true,
    //             //     isDeleted: false,
    //             //     loadedByUser: false,
    //             //     medicalExaminationTimestamp: undefined,
    //             //     mimeType: selectedFile.type,
    //             //     notes: props.notes,
    //             //     originalFileName: selectedFile.name,
    //             //     uploadedFileName: selectedFile.name,
    //             //     fileName: selectedFile.name,
    //             //     base64: b64,
    //             // } as medicalExamination;
    //             // props.addMedicalExamination(props.userId, i);
    //         });
    //     }
    // };

    React.useEffect(() => {
        console.log("-- MedicalExaminationDocument ----------------------------------------------- LOAD_1:", props.selectedMedicalExamination)
        if (props.selectedMedicalExamination === undefined) {
            console.log("-- MedicalExaminationDocument ----------------------------------------------- LOAD_2:", props.subscription)
            if (props.subscription) {
                console.log("-- MedicalExaminationDocument ----------------------------------------------- LOAD_3:", props.subscription.medicalExaminationDocumentId)
                if (props.subscription.medicalExaminationDocumentId) {
                    getByMexId(props.subscription.medicalExaminationDocumentId);
                }
            }
        }
    }, [])

    React.useEffect(() => {
        console.log("-- MedicalExaminationDocument ----------------------------------------------- selectedMedicalExamination:", props.selectedMedicalExamination)
        if (props.selectedMedicalExamination && props.selectedMedicalExamination !== null) {
            props.onUpdateMedicalExaminationDocument(props.selectedMedicalExamination)
        }
    }, [props.selectedMedicalExamination])

    React.useEffect(() => {
        console.log("-- MedicalExaminationDocument ----------------------------------------------- isLoadingMex:", props.isLoadingMex)
    }, [props.isLoadingMex])

    // CZ ------ React.useEffect(() => {
    // CZ ------     console.log("------------------------------------------------- newMedicalExamination:", props.newMedicalExamination)
    // CZ ------     if (props.newMedicalExamination && props.newMedicalExamination.isDeleted) {
    // CZ ------         // setSelectedFile(null);
    // CZ ------         setDocummentId(null);
    // CZ ------         setFirebaseUri(null);
    // CZ ------         props.resetNewMedicalExamination();
    // CZ ------     }
    // CZ ------     else if (props.newMedicalExamination) {
    // CZ ------         setDocummentId(props.newMedicalExamination._id)
    // CZ ------         setFirebaseUri(props.newMedicalExamination.firebaseUri)
    // CZ ------     }
    // CZ ------     props.onUpdateMedicalExaminationDocument(props.newMedicalExamination)
    // CZ ------ }, [props.newMedicalExamination])

    return (
        <div style={{ marginTop: '20px' }}>
            <input style={{ backgroundColor: 'lightgrey', borderBottom: '0px solid grey', borderRight: '1px solid grey', marginRight: '2px' }} type="file" onChange={onFileChange} />
            {/* {selectedFile && <button style={{ margin: '2px' }} onClick={onFileUpload}>Salva il documento</button>} */}

            {(props.selectedMedicalExamination) && <button style={{ margin: '2px' }} onClick={fileDelete}>Elimina il documento</button>}
            {(props.selectedMedicalExamination) &&
                <Typography style={{ marginTop: '1px', paddingLeft: '0px' }}>
                    <a style={{ cursor: 'pointer' }} onClick={() => { winOpen(props.selectedMedicalExamination.firebaseUri) }} href={props.selectedMedicalExamination.firebaseUri} target='_blank' rel='noopener noreferrer'>{'apri visita medica'}</a>
                </Typography>}

            {/* <button style={{ margin: '2px' }} onClick={fileTest}>TEST</button> */}
            {/* {fileData()} */}
            {/* <br /> */}
            {/* NEW:{JSON.stringify(props.newMedicalExamination)} */}
            {/* DOCUMENTID:{documentId} */}
            {/* <br /> */}
            {/* FIREBASE:{firebaseUri} */}
        </div>
    );
}

const mapStateToProps = (state: IApplicationState, ownProps: any): any => {
    return {
        ...ownProps,
        ...state.medicalExaminations
    }
}

const mapDispatchToProps = (dispatch: any) => ({
    ...medicalExaminationActions(dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)((WithMediaQuery(MedicalExaminationDocument))) as React.ComponentType<IInnerProps>;
